// Notification utility for browser push notifications

export const requestNotificationPermission = async () => {
    if (!('Notification' in window)) {
        console.log('This browser does not support notifications');
        return false;
    }

    if (Notification.permission === 'granted') {
        return true;
    }

    if (Notification.permission !== 'denied') {
        const permission = await Notification.requestPermission();
        return permission === 'granted';
    }

    return false;
};

export const sendDeliveryNotification = (trackingNumber, carrierName) => {
    if (Notification.permission !== 'granted') {
        return;
    }

    const notification = new Notification('Package Delivered! 📦', {
        body: `Your package ${trackingNumber} via ${carrierName} has been delivered.`,
        icon: '/favicon.ico',
        badge: '/favicon.ico',
        tag: `delivery-${trackingNumber}`,
        requireInteraction: true,
    });

    notification.onclick = () => {
        window.focus();
        notification.close();
    };

    // Auto-close after 10 seconds
    setTimeout(() => notification.close(), 10000);
};

export const checkNotificationSupport = () => {
    return 'Notification' in window;
};
